import React from 'react';

const ZOBOX_PRIMARY = '#2b3380';

/**
 * WorkflowIndicator Component
 * Shows a visual process flow with completed, active, and upcoming steps
 * 
 * @param {Array} steps - Array of step objects: [{ id, label, status: 'completed'|'active'|'upcoming' }]
 * @param {string} currentStep - ID of the current active step
 */
function WorkflowIndicator({ steps, currentStep }) {
  const getStepStatus = (step) => {
    const currentIndex = steps.findIndex(s => s.id === currentStep);
    const stepIndex = steps.findIndex(s => s.id === step.id);
    
    if (stepIndex < currentIndex) return 'completed';
    if (stepIndex === currentIndex) return 'active';
    return 'upcoming';
  };

  const getStepIcon = (status) => {
    if (status === 'completed') return '✓';
    if (status === 'active') return '●';
    return '○';
  };

  const getStepColor = (status) => {
    if (status === 'completed') return '#10b981'; // green
    if (status === 'active') return ZOBOX_PRIMARY;
    return '#9ca3af'; // gray
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => {
          const status = getStepStatus(step);
          const color = getStepColor(status);
          
          return (
            <React.Fragment key={step.id}>
              {/* Step */}
              <div className="flex flex-col items-center" style={{ minWidth: '120px' }}>
                <div 
                  className="flex items-center justify-center w-10 h-10 rounded-full text-white font-bold mb-2 transition-all"
                  style={{ 
                    backgroundColor: color,
                    transform: status === 'active' ? 'scale(1.1)' : 'scale(1)',
                    boxShadow: status === 'active' ? `0 0 0 4px ${color}20` : 'none'
                  }}
                >
                  {getStepIcon(status)}
                </div>
                <div 
                  className={`text-sm font-medium text-center transition-all ${
                    status === 'active' ? 'font-bold' : ''
                  }`}
                  style={{ 
                    color: status === 'active' ? ZOBOX_PRIMARY : status === 'completed' ? '#10b981' : '#6b7280'
                  }}
                >
                  {step.label}
                </div>
              </div>

              {/* Arrow connector (except for last item) */}
              {index < steps.length - 1 && (
                <div className="flex-1 flex items-center px-4" style={{ marginBottom: '40px' }}>
                  <div 
                    className="h-1 flex-1 transition-all"
                    style={{ 
                      backgroundColor: status === 'completed' ? '#10b981' : '#e5e7eb',
                      opacity: status === 'completed' ? 1 : 0.5
                    }}
                  />
                  <div 
                    style={{ 
                      width: 0,
                      height: 0,
                      borderTop: '6px solid transparent',
                      borderBottom: '6px solid transparent',
                      borderLeft: `10px solid ${status === 'completed' ? '#10b981' : '#e5e7eb'}`,
                      opacity: status === 'completed' ? 1 : 0.5,
                      marginLeft: '-2px'
                    }}
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}

export default WorkflowIndicator;
